<template>
  <div class="ml-2">
    <a href="#" class="my-auto mb-1 btn btn-sm btn-secondary" data-toggle="modal" data-target="#addTableModal"
       title="Add table" :style="{'height': '30px'}">
      <span class="mr-2 d-none d-md-inline-block">Add table</span>
      <span class="icon icon-add-more mr-0"></span>
    </a>
    <div class="modal fade" id="addTableModal" tabIndex="-1" aria-labelledby="addTableModalTitle" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="addTableModalTitle">Add new tables</h5>
            <button type="button" id="closeModalButton" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col">
                <label for="inputFile">From disk</label>
                <div class="input-group">
                  <input type="file" id="inputFile" class="d-none form-control form-control-file btn btn-secondary"
                         multiple v-on:change="onFilesSelected" :accept="acceptedForFileUpload">
                  <input type="text" class="form-control" aria-describedby="browseButton" :value="selectedFilesNames"
                         readonly>
                  <a href="#" role="button" class="btn btn-secondary popover-test" title="Select files to upload"
                     onClick="document.getElementById('inputFile').click()">Browse</a>
                </div>
                <small class="ml-2 align-middle mt-1 pt-1">{{
                    $tc('pluralized-files-selected', selectedFiles.length)
                  }}</small>
              </div>

              <ProgressBar class=""
                           v-bind:invisible="addTableFromFilesIsInProgress === false"
                           v-bind:striped="true"
                           v-bind:animated="true"
                           v-bind:animatedIndeterminate="true">
              </ProgressBar>


            </div>
            <hr>
            <div class="form-row">
              <div class="form-group col">
                <label for="goldStandardNameSelection">From Gold Standard</label>
                <div class="input-group">
                  <select class="custom-select" id="goldStandardNameSelection" v-model="goldStandardNameSelection"
                          v-on:change="goldStandardNameSelectionChange">

                    <option>Choose a Gold Standard...</option>
                    <option v-for="goldStandard of goldStandardList" :key="goldStandard.name">{{
                        goldStandard.name
                      }}
                    </option>

                  </select>
                  <a href="#" role="button" class="btn btn-secondary popover-test" title="Select files to upload"
                     v-on:click="selectClick"
                     :class="{disabled: goldStandardNameSelection === 'Choose a Gold Standard...'}">Select</a>
                </div>
                <div class="form-check form-check-inline ml-3 mt-2">
                  <input class="form-check-input" type="radio" name="goldStandardOptions" id="goldStandardOptionsAll"
                         value="All" v-model="goldStandardOptions" v-on:change="onChangeGoldStandardOptions"
                         :disabled="goldStandardNameSelection === 'Choose a Gold Standard...'">
                  <label class="form-check-label" for="goldStandardOptionsAll">Complete Gold Standard</label>
                </div>
                <div class="form-check form-check-inline ml-3">
                  <input class="form-check-input" type="radio" name="goldStandardOptions"
                         id="goldStandardOptionsPartialSelection" value="PartialSelection" v-model="goldStandardOptions"
                         v-on:change="onChangeGoldStandardOptions"
                         :disabled="goldStandardNameSelection === 'Choose a Gold Standard...'">
                  <label class="form-check-label" for="goldStandardOptionsPartialSelection">A partial Gold Standard
                    selection</label>
                </div>

                <div class="form-group mb-1">
                  <label class="d-none" for="customGoldStandardFilesSelect" sr-only="Gold Standard Files">Gold Standard
                    Files:</label>
                  <select class="form-control" id="customGoldStandardFilesSelect" multiple
                          v-model="customGoldStandardFilesSelect" :disabled="goldStandardOptions === 'All'">

                    <option v-for="selectedGoldStandardFile in selectedGoldStandardFiles"
                            :key="selectedGoldStandardFile">{{ selectedGoldStandardFile }}
                    </option>

                  </select>
                </div>

                <small class="ml-2 align-middle">{{
                    $tc('pluralized-files-selected', selectedGoldStandardLength)
                  }}</small>
              </div>
            </div>

            <ProgressBar class=""
                         v-bind:invisible="addTableFromGoldStandardIsInProgress === false"
                         v-bind:striped="true"
                         v-bind:animated="true"
                         v-bind:animatedIndeterminate="true">
            </ProgressBar>

            <div v-if="showAdvancedOptions" class="accordion mt-4" id="advancedAccordion">
              <div class="card">
                <div class="card-header" id="advancedAccordionHeader">
                  <h4 class="mb-0">
                    <button class="btn btn-link btn-sm btn-ligth" type="button" data-toggle="collapse"
                            data-target="#advancedAccordionBody" aria-expanded="false"
                            aria-controls="advancedAccordionBody">
                      <small>Advanced options</small>
                    </button>
                  </h4>
                </div>

                <div id="advancedAccordionBody" class="collapse" aria-labelledby="advancedAccordionHeader"
                     data-parent="#advancedAccordion">
                  <div class="input-group">
                    <select class="custom-select" id="collectionNameSelection" v-model="collectionNameSelection"
                            v-on:change="collectionNameSelectionChange">

                      <option>Choose a collection...</option>
                      <option v-for="collection of selectedProjectCollections" :key="collection">{{
                          collection
                        }}
                      </option>

                    </select>
                  </div>
                  <div class="form-row">
                    <div class="form-group col mt-2">
                      <label for="inputFile">Launching Action(s)</label>
                      <div class="input-group">
                        <select class="custom-select form-control" id="selectedLaunchingActions"
                                v-model="launchingActionsSelected">
                          <option value="none">None ( only upload file )</option>
                          <option value="preprocessing">Preprocessing</option>
                          <!--
                          <option value="preprocessingAndAnnotation" disabled title="Coming soon">Preprocessing & Annotation</option>
                          -->
                        </select>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>


          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Abort</button>
            <button type="button" class="btn btn-primary" v-on:click="onAddTablesSubmit">Add these tables</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableApi from '../../generatedApiClient/api/endpoints/TableApi';

let tableApiInstance = new TableApi();
import GoldStandardApi from '../../generatedApiClient/api/endpoints/GoldStandardApi';

let goldStandardApiInstance = new GoldStandardApi();

import ProgressBar from '@/components/global/ProgressBar.vue'

export default {
  name: "TablesUploader",
  components: {
    ProgressBar,
  },
  data() {
    return {
      collectionNameSelection: "Choose a collection...",
      selectedFiles: [],
      goldStandardNameSelection: "Choose a Gold Standard...",
      goldStandardOptions: "All",
      customGoldStandardFilesSelect: [],
      goldStandardList: [],
      createTablesErrors: [],
      addTableFromFilesIsInProgress: false,
      addTableFromGoldStandardIsInProgress: false,
      showAdvancedOptions: true,
      launchingActionsSelected: 'preprocessing'
    }
  },
  mounted() {
    this.updateGoldStandardTablesListContent();
  },
  computed: {
    acceptedForFileUpload: function () {
      return ".csv, .txt, .tsv, .xls, .xlsx";
    },
    signedUser: function () {
      return (this.$store.state.identityIdentified !== undefined) ? this.$store.state.identityIdentified.email : undefined;
    },
    selectedProjectId: function () {
      return (this.$store.state.selectedProject !== undefined) ? this.$store.state.selectedProject.id : undefined;
    },
    selectedProjectCollections: function () {
      return (this.$store.state.selectedProject !== undefined) ? this.$store.state.selectedProject.collections : undefined;
    },
    selectedFilesNames: function () {
      return this.selectedFiles.map(selectedFile => {
        return selectedFile.name;
      });
    },
    selectedGoldStandardFiles: function () {
      const goldStandardSelected = this.goldStandardList.filter(goldStandard => {
        return goldStandard.name === this.goldStandardNameSelection;
      });
      let returnedGoldStandardFiles = [];
      if ((goldStandardSelected.length === 1) && (goldStandardSelected[0].files !== undefined)) {
        returnedGoldStandardFiles = goldStandardSelected[0].files;
      }
      return returnedGoldStandardFiles;
    },
    selectedGoldStandardLength: function () {
      if (this.goldStandardOptions === 'All') {
        return this.selectedGoldStandardFiles.length;
      } else if (this.goldStandardOptions === 'PartialSelection') {
        return this.customGoldStandardFilesSelect.length;
      } else {
        return 0;
      }
    }
  },
  methods: {
    updateAuthJwtToken: function (apiInstance) {
      if (apiInstance && apiInstance.apiClient && apiInstance.apiClient.authentications && apiInstance.apiClient.authentications['AuthJWT']) {
        apiInstance.apiClient.authentications['AuthJWT'].accessToken = this.$store.state.identityIdentified.token;
      }
    },
    emitSomeTablesAreCreated: function () {
      this.$emit('some-tables-are-created', {});
    },
    onFilesSelected: function (event) {
      const selectedFilesArray = [];
      event.target.files.forEach(selectedFile => {
        selectedFilesArray.push(selectedFile);
      });
      this.selectedFiles = selectedFilesArray;
      this.resetInputsFromGoldStandard();
    },
    resetInputsFromGoldStandard: function () {
      this.goldStandardNameSelection = "Choose a Gold Standard...";
      this.goldStandardOptions = "All";
      this.customGoldStandardFilesSelect = [];
    },
    resetInputsFromFile: function () {
      this.selectedFiles = [];
    },
    selectClick: function () {
      this.resetInputsFromFile();
    },
    goldStandardNameSelectionChange: function () {
      this.resetInputsFromFile();
      this.goldStandardOptions = "All";
      this.customGoldStandardFilesSelect = [];
    },
    onChangeGoldStandardOptions: function () {
      this.resetInputsFromFile();
      this.customGoldStandardFilesSelect = [];
    },
    collectionNameSelectionChange: function () {
      // this.collectionNameSelection = undefined;
    },
    // onAddTablesSubmit: function(event) {
    onAddTablesSubmit: function () {
      if (this.selectedFiles.length > 0) {
        console.log('[onAddTablesSubmit] from files');
        this.addTableFromFilesIsInProgress = true;
        let result = Promise.resolve();
        this.selectedFiles.forEach(file => {
          result = result.then(() => this.createTableFromFile(this.signedUser, this.selectedProjectId, file, this.launchingActionsSelected));
        });
        result = result.then(() => {
          return new Promise((resolve) => {
            this.addTableFromFilesIsInProgress = false;
            this.resetInputsFromGoldStandard();
            this.resetInputsFromFile();
            document.getElementById('closeModalButton').click();
            this.emitSomeTablesAreCreated();
            resolve(true);
          });
        });
        return result;
      } else if (this.goldStandardNameSelection !== "Choose a Gold Standard...") {
        console.log('[onAddTablesSubmit] from Gold Standard');
        this.addTableFromGoldStandardIsInProgress = true;
        let goldStandardFiles = this.customGoldStandardFilesSelect;
        if (this.goldStandardOptions === "All") {
          goldStandardFiles = undefined;
        }
        let result = this.createTableFromGoldStandard(this.signedUser, this.selectedProjectId, this.goldStandardNameSelection, goldStandardFiles, this.launchingActionsSelected);
        result = result.then(() => {
          return new Promise((resolve) => {
            this.addTableFromGoldStandardIsInProgress = false;
            this.resetInputsFromGoldStandard();
            this.resetInputsFromFile();
            document.getElementById('closeModalButton').click();
            this.emitSomeTablesAreCreated();
            resolve(true);
          });
        });
        return result;
      }
    },
    createTableFromFile: function (signedUser, projectId, file, pipedTasks) {
      return new Promise((resolve, reject) => {
        this.updateAuthJwtToken(tableApiInstance);
        if (this.collectionNameSelection !== "Choose a collection...") {
          tableApiInstance.createTable(signedUser, projectId, file.name, 'Disk', file, {
            pipedTasks: pipedTasks,
            projectCollection: this.collectionNameSelection
          })
              .then(createTableResp => {
                console.log("[createTableFromFile] [API] [createTable] [OK]");
                resolve(createTableResp);
              })
              .catch(createTableError => {
                console.log("[createTableFromFile] [API] [createTable] [ERROR]", createTableError);
                reject(createTableError);
              });
        } else {
          tableApiInstance.createTable(signedUser, projectId, file.name, 'Disk', file, {pipedTasks: pipedTasks})
              .then(createTableResp => {
                console.log("[createTableFromFile] [API] [createTable] [OK]");
                resolve(createTableResp);
              })
              .catch(createTableError => {
                console.log("[createTableFromFile] [API] [createTable] [ERROR]", createTableError);
                reject(createTableError);
              });
        }

      });
    },
    updateGoldStandardTablesListContent: function () {
      this.updateAuthJwtToken(goldStandardApiInstance);
      goldStandardApiInstance.getGoldStandardsTables()
          .then(getGoldStandardsTablesResp => {
            console.log("[updateGoldStandardTablesListContent] [API] [getGoldStandardsTables] [OK]");
            this.goldStandardList = getGoldStandardsTablesResp;
          })
          .catch(getGoldStandardsTablesError => {
            console.log("[updateGoldStandardTablesListContent] [API] [getGoldStandardsTables] [ERROR]", getGoldStandardsTablesError);
          });
    },
    createTableFromGoldStandard: function (signedUser, projectId, goldStandardName, goldStandardFiles, pipedTasks) {
      return new Promise((resolve, reject) => {
        this.updateAuthJwtToken(tableApiInstance);
        if (this.collectionNameSelection !== "Choose a collection...") {

          tableApiInstance.createTablesFromGoldStandard(signedUser, projectId, {
            name: goldStandardName,
            files: goldStandardFiles,
            projectCollection: this.collectionNameSelection

          }, {pipedTasks: pipedTasks})
              .then(createTablesFromGoldStandardResp => {
                console.log("[createTableFromGoldStandard] [API] [createTablesFromGoldStandard] [OK]");
                resolve(createTablesFromGoldStandardResp);
              })
              .catch(createTablesFromGoldStandardError => {
                console.log("[createTableFromGoldStandard] [API] [createTablesFromGoldStandard] [ERROR]", createTablesFromGoldStandardError);
                reject(createTablesFromGoldStandardError);
              });
        } else {
          tableApiInstance.createTablesFromGoldStandard(signedUser, projectId, {
            name: goldStandardName,
            files: goldStandardFiles
          }, {pipedTasks: pipedTasks})
              .then(createTablesFromGoldStandardResp => {
                console.log("[createTableFromGoldStandard] [API] [createTablesFromGoldStandard] [OK]");
                resolve(createTablesFromGoldStandardResp);
              })
              .catch(createTablesFromGoldStandardError => {
                console.log("[createTableFromGoldStandard] [API] [createTablesFromGoldStandard] [ERROR]", createTablesFromGoldStandardError);
                reject(createTablesFromGoldStandardError);
              });
        }
      });
    }
  }
}
</script>

<style scoped>

.modal {
  font-size: medium;
}

</style>